import { render, staticRenderFns } from "./organization-risk-form.vue?vue&type=template&id=0a128ca5&scoped=true&"
import script from "./organization-risk-form.vue?vue&type=script&lang=js&"
export * from "./organization-risk-form.vue?vue&type=script&lang=js&"
import style0 from "./organization-risk-form.vue?vue&type=style&index=0&id=0a128ca5&lang=scss&scoped=true&"
import style1 from "./organization-risk-form.vue?vue&type=style&index=1&id=0a128ca5&scoped=true&lang=css&"
import style2 from "./organization-risk-form.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a128ca5",
  null
  
)

export default component.exports